/**
 * Client side of the permission layer. The engine is the gate (`requireStaff(permission)` on
 * every /admin route); this only decides what to SHOW. The permission keys are the engine's
 * (`engine.*`), carried by `useAuth().enginePermissions`.
 */

/**
 * Visibility rule shared by the dock, the phone's home and deep links. Owner sees everything.
 * Everyone else is decided by the permission list the engine computed.
 */
export function canSee(appPermission: string | null, role: string | undefined, permissions: readonly string[]): boolean {
  if (appPermission === null) return true;
  if (role === "owner") return true;
  return permissions.includes(appPermission);
}
